__turbopack_context__.v({
  "menuContainer": "MenuContent-module__-0LGtq__menuContainer",
  "menuList": "MenuContent-module__-0LGtq__menuList",
});
